// INFORMEIMAGE requests
export const INFORMEIMAGE_LIST = "INFORMEIMAGE_LIST";
export const INFORMEIMAGE_LISTA = "INFORMEIMAGE_LISTA";
export const INFORMEIMAGE_CREATE = "INFORMEIMAGE_CREATE";
export const INFORMEIMAGE_FILTER = "INFORMEIMAGE_FILTER";
export const INFORMEIMAGE_UPDATE = "INFORMEIMAGE_UPDATE";
export const INFORMEIMAGE_DELETE = "INFORMEIMAGE_DELETE";
export const INFORMEIMAGE_READ = "INFORMEIMAGE_READ";

// INFORMEIMAGE success
export const INFORMEIMAGE_LIST_SUCCESS = "INFORMEIMAGE_LIST_SUCCESS";
export const INFORMEIMAGE_CREATE_SUCCESS = "INFORMEIMAGE_CREATE_SUCCESS";
export const INFORMEIMAGE_UPDATE_SUCCESS = "INFORMEIMAGE_UPDATE_SUCCESS";
export const INFORMEIMAGE_DELETE_SUCCESS = "INFORMEIMAGE_DELETE_SUCCESS";
export const INFORMEIMAGE_READ_SUCCESS = "INFORMEIMAGE_READ_SUCCESS";

// INFORMEIMAGE failed
export const INFORMEIMAGE_REQUEST_FAILED = "INFORMEIMAGE_REQUEST_FAILED";
